import { enableProdMode, importProvidersFrom, provideAppInitializer } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { UrlSerializer } from '@angular/router';
import { AppComponent } from './app/app.component';
import { APP_ROUTES_PROVIDER } from './app/app.routes.module';
import { HttpInterceptorService } from './app/shared/interceptors/http.interceptor';
import { loadCookiebot } from './app/shared/utils/cookiebot.utils';
import { TrailingSlashUrlSerializer } from './app/shared/utils/url-serializer.util';
import { environment } from './environments/environment';

import { CurrencyPipe } from '@angular/common';
import 'hammerjs';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { IconsModule } from './app/shared/icons/icons.module';
import MyPreset from './app/theme/theme';

function appInit(): Promise<void> | void {
  loadCookiebot();
}
const hammerConfig = new HammerGestureConfig();

if (environment.production) {
  enableProdMode();
}

// Unregister any leftover service worker from previous deployments and clear
// its caches, then reload once so the fresh bundle is loaded without SW interference.
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then(regs => {
      if (!regs.length) return;
      return Promise.all(regs.map(r => r.unregister()))
        .then(() => (typeof caches !== 'undefined' ? caches.keys() : Promise.resolve([] as string[])))
        .then(keys => Promise.all(keys.map(k => caches.delete(k))))
        .then(() => window.location.reload());
    })
    .catch(() => {});
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(HammerModule, IconsModule),
    ...APP_ROUTES_PROVIDER,
    { provide: UrlSerializer, useClass: TrailingSlashUrlSerializer },
    // HTTP interceptor for auth
    HttpInterceptorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    // App initializer for startup
    provideAppInitializer(appInit),
    { provide: HAMMER_GESTURE_CONFIG, useValue: hammerConfig, deps: [] },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
      },
    }),
    ConfirmationService,
    DialogService,
    MessageService,
    CurrencyPipe,
  ],
}).catch(err => console.log(err));
